import type { Database } from "@excel-center/supabase";
import { z } from "zod";

type DBJobEmploymentType = Database["public"]["Enums"]["job_employment_type"];

export const JobEmploymentType = {
	FULL_TIME: "full_time",
	PART_TIME: "part_time",
	CONTRACT: "contract",
	INTERNSHIP: "internship",
	APPRENTICESHIP: "apprenticeship",
} as const satisfies Record<string, DBJobEmploymentType>;

export type JobEmploymentType = (typeof JobEmploymentType)[keyof typeof JobEmploymentType];

type _EnsureAllDBValues = Exclude<DBJobEmploymentType, JobEmploymentType> extends never ? true : never;
const _check: _EnsureAllDBValues = true;
void _check;

export const JOB_EMPLOYMENT_TYPES = Object.values(JobEmploymentType) as readonly JobEmploymentType[];

export const jobEmploymentTypeSchema = z.enum(JobEmploymentType);
